import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { ProductConsumer } from "../Context/AddProWakel";
import PropTypes from "prop-types";
class Product extends React.Component {
  render() {
    const { id, title, img } = this.props.product;
    return (
      <>
        <ProductWraper className="col-9 mx-auto col-md-6 col-lg-3 my-3">
          <div className="card ">
            <ProductConsumer>
              {(value) => (
                <div className="img-container p-5">
                  <Link
                    to={`${
                      id == 1
                        ? `/rent?page=${value.R_zh_wasl_katy}`
                        : id == 2
                        ? "/add-product"
                        : id == 3
                        ? "/add-wakel"
                        : id == 4
                        ? "/take-money"
                        : id == 8
                        ? "/masrufat"
                        : id == 5
                        ? "/back-koga"
                        : id == 7
                        ? "/Product-Raport"
                        : "/"
                    }`}
                  >
                    <img
                      src={img}
                      onClick={
                        id == 6 ? () => value.Q_OpenModal(value.L_user._id) : undefined
                      }
                      alt="product"
                      className="card-img-top "
                    />
                  </Link>
                </div>
              )}
            </ProductConsumer>
            {/* footer of cart */}
            <div
              className="card-footer d-flex justify-content-center h2"
              style={{ color: "#000C66" }}
            >
              <p className="align-self-center mb4 ">{title}</p>
            </div>
          </div>
        </ProductWraper>
      </>
    );
  }
}

Product.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.number,
    img: PropTypes.string,
    title: PropTypes.string,
    price: PropTypes.number,
    inCart: PropTypes.bool
  }).isRequired
};

const ProductWraper = styled.div`
  cursor: pointer;
  
  .card {
    border: none;
    border-radius: 15px;
    background: linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
    height: 100%;
    
    &:hover {
      transform: translateY(-10px);
      box-shadow: 0 15px 40px rgba(0, 0, 0, 0.25);
      background: linear-gradient(145deg, #ffffff 0%, #e8f4f8 100%);
    }
  }

  .card-footer {
    background: linear-gradient(to top, rgba(44, 53, 57, 0.05), transparent);
    border-top: none;
    padding: 1.2rem;
    transition: all 0.4s ease;
    
    p {
      margin: 0;
      font-weight: 600;
      color: #2C3539;
      text-shadow: 0 1px 2px rgba(255, 255, 255, 0.8);
    }
  }
  
  .card:hover .card-footer {
    background: linear-gradient(to top, rgba(52, 152, 219, 0.1), transparent);
    
    p {
      color: #3498db;
    }
  }

  .img-container {
    position: relative;
    overflow: hidden;
    padding: 2rem !important;
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: radial-gradient(circle at center, rgba(52, 152, 219, 0.1) 0%, transparent 70%);
      opacity: 0;
      transition: opacity 0.4s ease;
    }
    
    &:hover::before {
      opacity: 1;
    }
  }

  .card-img-top {
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
    max-height: 150px;
    width: auto;
    object-fit: contain;
  }

  .img-container:hover .card-img-top {
    transform: scale(1.15) rotate(2deg);
    filter: drop-shadow(0 8px 16px rgba(52, 152, 219, 0.3));
  }

  .card-btn {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 0.2rem 0.4rem;
    background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
    border: none;
    color: #ffffff;
    font-size: 1.4rem;
    border-radius: 0.5rem 0 0 0;
    transform: translate(100%, 100%);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 15px rgba(52, 152, 219, 0.3);
  }

  .img-container:hover .card-btn {
    transform: translate(0, 0);
  }

  .card-btn:hover {
    background: linear-gradient(135deg, #2980b9 0%, #3498db 100%);
    color: #ffffff;
    cursor: pointer;
    box-shadow: 0 6px 20px rgba(52, 152, 219, 0.5);
  }

  /* Responsive adjustments */
  @media (max-width: 768px) {
    .card {
      margin-bottom: 1rem;
    }
    
    .img-container {
      min-height: 180px;
      padding: 1.5rem !important;
    }
  }
`;

export default Product;
